export default __webpack_public_path__ + "static/EnergAIse-2c86fb8a5c440bb3573ab5a9f96f0b5f.jpg";